import { createContext } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type { BundlingContract } from '@raas/shared/src/features/bundling/contracts/bundling.type';

export interface BundlingDataContextContract {
  currentBundling: BundlingContract | null;
  setCurrentBundling: Dispatch<SetStateAction<BundlingContract | null>>;
  isCurrentLoading: boolean;
  setIsCurrentLoading: (isLoading: boolean) => void;
  bundlings: BundlingContract[];
  setBundlings: Dispatch<SetStateAction<BundlingContract[]>>;
  isListLoading: boolean;
  setIsListLoading: (isLoading: boolean) => void;
}

const BundlingDataContext = createContext<BundlingDataContextContract | undefined>(undefined);

export default BundlingDataContext;
